import { createSlice } from '@reduxjs/toolkit';

import { State, STATE } from '../types/state';

import setSettings from './setSettings';
import updateSettings from './updateSettings';
import setSettingsStatusLoading from './setSettingsStatusLoading';
import setUpdateSettingsStatusLoading from './setUpdateSettingsStatusLoading';

import setAutosCoordinates from './setAutosCoordinates';
import setAutosCoordinatesStatusLoading from './setAutosCoordinatesStatusLoading';
import resetAutosCoordinates from './resetAutosCoordinates';
import { setUSerCurrentLocation } from './setUserCurrentLocation';
import { resetUserCurrentLocation } from './resetUserCurrentLocation';
import setUserCardsLoading from './setUserCardsLoading';
import setUserCards from './setUserCards';
import setHistoryUserLocation from './setHistoryUserLocation';
import setHistoryUserLocationLoading from './setHistoryUserLocationLoading';
import resetHistoryUserLocation from './resetHistoryUserLocation';
import setUserGeoPosition from './setUserGeoPosition';
import resetUserGeoPosition from './resetUserGeoPosition';
import setUserGeoPositionLoading from './setUserGeoPositionLoading';

const initialState: State = {
  settings: {},
  autosCoordinates: {},
  currentLocation: {},
  cards: {},
  historyUserLocation: {},
  geoPosition: {},
};

const slice = createSlice({
  name: STATE,
  initialState,
  reducers: {
    setSettings,
    updateSettings,
    setSettingsStatusLoading,
    setUpdateSettingsStatusLoading,

    setAutosCoordinates,
    setAutosCoordinatesStatusLoading,
    resetAutosCoordinates,

    resetUserCurrentLocation,

    setUserCards,
    setUserCardsLoading,

    setHistoryUserLocation,
    setHistoryUserLocationLoading,
    resetHistoryUserLocation,

    setUserGeoPosition,
    resetUserGeoPosition,
    setUserGeoPositionLoading,
  },
  extraReducers: (builder) => {
    setUSerCurrentLocation(builder);
  },
});

export default slice;
